const Table = () => import('@/../../coreui/components/ServerTable')
export default function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Metrc'))  {
    return [
      {
        path: '/MetrcPrefs',
        name: 'MetrcPrefs',
        component: Table,
        props: {
          schema: "sch_metrc_prefs",
          table: "metrc_prefs",
        }
      }
  ] } else return []
}
